import type { Ref } from 'vue';
import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = (menuHeight: Ref<number>) => {
  const theme = useTheme();
  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      boxSizing: 'border-box',
    },
    position: 'relative',
    width: 'fit-content',
    '&__menu': {
      position: 'absolute',
      display: 'none',
      padding: '0.625rem',
      background: '#fff',
      boxShadow: '0px 6px 30px 0px rgba(0, 0, 0, 0.10)',
      borderBottomLeftRadius: '0.5rem',
      borderBottomRightRadius: '0.5rem',
      marginTop: '0.5rem',
      zIndex: 20,
    },
    '&--active &__menu': {
      display: 'block',
    },
    '&--center &__menu': {
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
    },
    '&--top-center &__menu': {
      borderRadius: '0.5rem',
    },
    '&--top-left &__menu': {
      right: '100%',
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
      borderBottomRightRadius: '0',
    },
    '&--top-right &__menu': {
      left: '100%',
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
      borderBottomLeftRadius: '0',
    },
    '&--left &__menu': {
      right: '100%',
      borderTopLeftRadius: '0.5rem',
    },
    '&--right &__menu': {
      left: '100%',
      borderTopRightRadius: '0.5rem',
    },
    '&--middle-left &__menu': {
      left: '-100%',
    },
    '&--middle-right &__menu': {
      right: 'unset',
    },
    '&--small &__menu': {
      width: '240px',
    },
    '&--large &__menu': {
      width: '340px',
    },
    '&--full-width &__menu': {
      width: '100%',
    },
    '[class*="--center"][class*="--small"]:not(&--full-width) &__menu': {
      left: 'calc(-120px + 50%)',
    },
    '[class*="--center"][class*="--large"]:not(&--full-width) &__menu': {
      left: 'calc(-170px + 50%)',
    },
    '[class*="--top"] &__menu': {
      top: `calc(-${menuHeight.value}px - 16px)`,
    },
    '[class*="--top-center"][class*="--small"]:not(&--full-width) &__menu': {
      left: 'calc(-120px + 50%)',
    },
    '[class*="--top-center"][class*="--large"]:not(&--full-width) &__menu': {
      left: 'calc(-170px + 50%)',
    },
    '&__divider': {
      width: '100%',
      height: '1px',
      background: theme.value.colors.gray.light3,
      marginBlock: '0.5rem',
    },
  }));

  return baseClass;
};

export const useMenuStyles = () => {
  const menuStyles = computed(() => css({
    position: 'fixed',
    display: 'none',
    padding: '0.625rem',
    background: '#fff',
    boxShadow: '0px 6px 30px 0px rgba(0, 0, 0, 0.10)',
    borderBottomLeftRadius: '0.5rem',
    borderBottomRightRadius: '0.5rem',
    zIndex: 30,

    '&--open': {
      display: 'block',
    },

    '&--small': {
      width: '240px',
    },

    '&--large': {
      width: '340px',
    },

    '&--center': {
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
    },

    '&--left': {
      borderTopLeftRadius: '0.5rem',
    },

    '&--right': {
      borderTopRightRadius: '0.5rem',
    },

    '&--top-center': {
      borderRadius: '0.5rem',
    },

    '&--top-left': {
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
      borderBottomRightRadius: '0',
    },

    '&--top-right': {
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
      borderBottomLeftRadius: '0',
    },
  }));

  return menuStyles;
};
